// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import MainIndex from '../index.vue'
import Login from '../components/UserLogin.vue'
import XiaoLiuRen from '../components/XiaoLiuRen.vue'
import BMIIndex from '../components/BMIIndex.vue'
import UserNote from '../components/Note.vue'
import PuzzleGame from '../components/PuzzleGame.vue'

const routes = [
  {
    path: '/',
    name: 'MainIndex',
    component: MainIndex,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/xiaoliuren',
    name: 'XiaoLiuRen',
    component: XiaoLiuRen,
    meta: { requiresAuth: true }
  },
  {
    path: '/bmi',
    name: 'BMIIndex',
    component: BMIIndex,
    meta: { requiresAuth: true }
  },
  {
    path: '/note',
    name: 'UserNote',
    component: UserNote,
    meta: { requiresAuth: true }
  },
  {
    path: '/puzzle',
    name: 'PuzzleGame',
    component: PuzzleGame,
    meta: { requiresAuth: true } 
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('username')
  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    next({ name: 'Login' })
  } else {
    next()
  }
})

export default router